
const FazaNaloga = function(DS) {
    return DS.defineResource({
        name: 'FazaNaloga',
        endpoint: '/fazeNaloga'
    });
};

FazaNaloga.$inject = ['DS'];


export {FazaNaloga};



// WEBPACK FOOTER //
// ./app/models/fazaNaloga.js